export class ArticleRepository<T> extends Repository<T> {
  constructor() {
    super(articleFetch);
  }
}
